import {ErrorFlow, Transaction, Brick, BrickContext, Predicate, Query, registerBrick} from 'olympe';
import Report from "../../../../models/Report";
import Unit from "../../../../models/Unit";
import ReportLinkMissingObservations from "./ReportLinkMissingObservations";

export default class ReportUnlinkObservations extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Report} report
     * @param {Unit} unit
     * @param {Array<Observation>} observations
     * @param {function()} forwardEvent
     * @param {function(ErrorFlow)} setErrorFlow
     */
    update($, [report, unit, observations], [forwardEvent, setErrorFlow]) {
        // Get all the entities that already have an observation in this unit to avoid duplicate
        const linkedObservations = new Set(Query.from(report)
            .follow(Report.observationsRel).andReturn()
            .follow(Unit.observationsRel.getInverse())
            .filter(Predicate.in(unit))
            .executeFromCache().keys());

        const transaction = new Transaction();

        observations.flatMap((observation) => {
            // Unlink all the observations from the children entities
            return ReportLinkMissingObservations.getObservationChildren(unit, observation);
        }).filter((observation) => {
            // Do not create observations for entities that already have one.
            return linkedObservations.has(observation.getTag());
        }).forEach((observation) => {
            transaction.deleteRelation(Report.observationsRel, report, observation);
        });

        transaction.execute().then(forwardEvent).catch((e) => {
            setErrorFlow(ErrorFlow.create(`Failed to remove observations to the report: ${e}`, 0));
        });
    }
}

registerBrick('018ae12c9c75fdbe1a34', ReportUnlinkObservations);
